export default "__VITE_ASSET__C5ciOEO1__"